export default "__VITE_ASSET__DIuVaOnG__"